const state = {
    province: null,
    city: null,
    district: null,
    roleList: [],
    provinceCode: null, 
    cityCode: null,
    districtCode: null,
}
//方法属性
const mutations = {
    SET_ROLELIST: (state, list) => {
        state.roleList = list;
    },
    RESET_ROLELIST: (state) => {
        state.roleList = [];
    },
    SET_AREA: (state, area) => {
        state.province = area.province;
        state.city = area.city;
        state.district = area.district;
        state.provinceCode = area.provinceCode;
        state.cityCode = area.cityCode;
        state.districtCode = area.districtCode;
    },
    RESET_AREA: (state) => {
        state.province = null;
        state.city = null;
        state.district = null;
        state.provinceCode = null;
        state.cityCode = null;
        state.districtCode = null;
    }
}
//异步属性
const actions = {

}

export default {
    namespaced: true,  //用于全局引用此文件里的方法时表示文件名，解决命名冲突问题
    state,
    mutations,
    actions,
}